import { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { toast } from 'sonner';
import { Loader2, SendHorizonal, CheckCircle2 } from 'lucide-react';
import { investmentsAPI } from '../../lib/api';
import { PaymentStatusBadge, TxHashLink } from './investmentShared';

const HASH_RE = /^(0x)?[0-9a-fA-F]{64}$/;

export const ConfirmPaymentForm = ({ request, onDone }) => {
    const [hash, setHash] = useState('');
    const [sending, setSending] = useState(false);
    const p = request.payment;

    const submit = async () => {
        const tx = hash.trim();
        if (!HASH_RE.test(tx)) { toast.error('Introduce un hash de transacción válido (64 caracteres)'); return; }
        setSending(true);
        try {
            await investmentsAPI.confirmPayment(request.id, { tx_hash: tx });
            toast.success('Pago enviado. Lo verificaremos en cadena y te avisaremos.');
            setHash('');
            onDone?.();
        } catch (e) {
            toast.error(e.response?.data?.detail || 'Error al confirmar el pago');
        } finally {
            setSending(false);
        }
    };

    if (p && p.status !== 'rejected') {
        return (
            <div className="rounded-lg bg-slate-950/70 border border-slate-800 px-3 py-2.5 space-y-1.5" data-testid={`investment-payment-info-${request.id}`}>
                <div className="flex flex-wrap items-center gap-2">
                    <PaymentStatusBadge payment={p} testId={`investment-payment-status-${request.id}`} />
                    <TxHashLink payment={p} testId={`investment-payment-tx-${request.id}`} />
                </div>
                {p.status === 'verified' && <p className="text-emerald-300 text-xs flex items-center gap-1.5"><CheckCircle2 className="w-3.5 h-3.5" /> Tu inversión ha quedado financiada y verificada en cadena.</p>}
            </div>
        );
    }

    return (
        <div className="space-y-2" data-testid={`investment-confirm-payment-${request.id}`}>
            {p?.status === 'rejected' && (
                <div className="flex flex-wrap items-center gap-2">
                    <PaymentStatusBadge payment={p} testId={`investment-payment-status-${request.id}`} />
                    {p.reject_reason && <span className="text-red-300 text-xs" data-testid={`investment-payment-reject-${request.id}`}>Motivo: {p.reject_reason}</span>}
                </div>
            )}
            <p className="text-[11px] uppercase tracking-wider font-bold text-slate-400">¿Ya realizaste el envío? Confirma tu pago</p>
            <div className="flex flex-col sm:flex-row gap-2">
                <Input value={hash} onChange={(e) => setHash(e.target.value)} placeholder="Hash / ID de la transacción (TXID)"
                    className="bg-slate-950 border-slate-800 text-white font-mono text-xs h-9 flex-1" data-testid={`investment-txhash-input-${request.id}`} />
                <Button size="sm" onClick={submit} disabled={sending || !hash}
                    className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold h-9" data-testid={`investment-confirm-payment-btn-${request.id}`}>
                    {sending ? <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" /> : <SendHorizonal className="w-3.5 h-3.5 mr-1.5" />}
                    Confirmar pago
                </Button>
            </div>
        </div>
    );
};
